import { ZoneRaw, ZoneNode } from "../../../types/sortingMachine";

const buildZoneTree = (flatZones: ZoneRaw[]): ZoneNode[] => {
	const nodeMap = new Map<number, ZoneNode>();

	for (const zone of flatZones) {
		nodeMap.set(zone.id, {
			id: zone.id,
			description: zone.description,
			levelId: zone.levelId,
			parentId: zone.parentId,
			children: [],
		});
	}

	const roots: ZoneNode[] = [];

	nodeMap.forEach((node) => {
		const isRoot = node.parentId === 0 || !nodeMap.has(node.parentId);

		if (isRoot) {
			roots.push(node);
		} else {
			const parent = nodeMap.get(node.parentId);
			parent?.children.push(node);
		}
	});

	const sortByDescription = (a: ZoneNode, b: ZoneNode): number =>
		a.description.localeCompare(b.description);

	const sortTree = (nodes: ZoneNode[]): void => {
		nodes.sort(sortByDescription);
		for (const node of nodes) {
			if (node.children.length > 0) {
				sortTree(node.children);
			}
		}
	};

	sortTree(roots);

	return roots;
};

export const collectAllDescendantIds = (node: ZoneNode): number[] => {
	const ids: number[] = [node.id];
	for (const child of node.children) {
		ids.push(...collectAllDescendantIds(child));
	}
	return ids;
};

export const collectLeafIds = (node: ZoneNode): number[] => {
	if (node.children.length === 0) {
		return [node.id];
	}
	const ids: number[] = [];
	for (const child of node.children) {
		ids.push(...collectLeafIds(child));
	}
	return ids;
};

export default buildZoneTree;
